import styled from 'styled-components'

export default styled.main`
 {
   margin-left: 16.7%;
   margin-right: 16.7%;
   font-family: 'Raleway', sans-serif;
 }
@media (max-width: 1200px) {}
@media (max-width: 992px) {
  margin-left: 7%;
  margin-right: 7%;
}
@media (max-width: 768px) {
  margin-left: 0.05%;
  margin-right: 0.05%;
}
`



// WEBPACK FOOTER //
// ./src/styles/StyledApp.js